import type { GreenlightRegistrationLookupResponse } from '../../../../api/historyCheck.typed';

export const useMapVehicleDataToKeyInfo = (
  vehicleData: GreenlightRegistrationLookupResponse | null,
) => {
  const keyInfo = {
    vehicleMetaTitle: '',
    vehicleMetaList: [],
    currentReport: null,
    keyInfoListItems: [],
  };

  if (vehicleData?.vehicleDetails) {
    const vehicleDetails = vehicleData.vehicleDetails;

    const { Make = '-', Model = '-', Year = '-' } = vehicleDetails;
    const vehicleMetaTitle = `${Year} ${Make} ${Model}`;

    const vehicleMetaList = Object.keys(vehicleDetails).map((key) => ({
      displayName: key,
      value: vehicleDetails[key],
    }));

    const currentReport = vehicleData.availableReports[0] || null;

    const keyInfoListItems = [vehicleData.registration, vehicleDetails.Trim];

    return {
      vehicleMetaTitle,
      vehicleMetaList,
      currentReport,
      keyInfoListItems,
    };
  }

  return keyInfo;
};
